import React from 'react';
import RegisterVehicleForm from './forms/RegisterVehicleForm';
import Crumb from '../../components/Crumb';
import { Helmet } from "react-helmet";

class VehicleRegister extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="content-wrapper pb-7">

                    <h2 className="aui-headline-3 mt-5">Add a vehicle</h2>
                    <Crumb className="mb-6" />

                    <div className="row">
                        <div className="col-5 d-none d-medium-block">
                            <div className="side-hero" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}assets/cvo-banner.jpg")`}}>&nbsp;</div>
                        </div>
                        <div className="col-12 col-medium">
                            <div className="px-0 px-small-5 px-large-7 py-3 py-medium-5 h-100">
                                <p className="mb-3">
                                    If you have just purchased a new or demonstrator vehicle from an Audi dealer, it will appear on myAudi Australia once your dealer processes the sale. This can take up to 72 hours.
                                </p>
                                <p className="mb-3">
                                    If you have purchased a pre-owned or privately listed Audi, you can add your vehicle by completing the <span className="d-none d-medium-inline">adjacent</span> <span className="d-medium-none">below</span> form.
                                </p>
                                <p className="mb-7">
                                    For assistance, please call Audi Customer Care on <a className="aui-textlink" href="tel:1800502834">1800 50 AUDI (2834)</a> between 8am and 6pm AEST, Monday to Friday. Please have your personal details (including your vehicle proof of purchase, vehicle model, VIN and registration) ready when you call.
                                </p>
                                <RegisterVehicleForm />
                            </div>
                        </div>
                    </div>
                </div>

                <Helmet>
                    <title>Register your Audi | myAudi Australia</title>
                </Helmet>
            </div>
        );
    }
}

export default VehicleRegister;
